import { User } from '../../../../types';
import { ConstructGet } from '../../../types/ConstructGet';
import { PaginatedResponse } from '../../../types/PaginatedResponse';
import { USER_BASE_PATH } from '../constants/userBasePath';
import { UserSearchParams } from '../types/UserSearchParams';

export const getUsers = (
  constructGet: ConstructGet,
  searchParams?: UserSearchParams,
): Promise<PaginatedResponse<User[]> | undefined> =>
  constructGet<PaginatedResponse<User[]>>(USER_BASE_PATH, {
    params: searchParams,
  });
